import { render } from "./addCustomer.vue?vue&type=template&id=0ae25040"
import script from "./addCustomer.vue?vue&type=script&lang=js"
export * from "./addCustomer.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__